window.Mailchimp = {

	elements: {
		body: $('body')
	},
	
	selector: {
		form				: '#mcpForm',
		formSync			: '#mcSyncForm',
		inputReload			: '#mcp_reload',
		listFieldsWrapper	: '#mcpForm .fields',
		listFields			: '#mcpForm .fields ul'
	},

	callSync: false,

	loadPrefs : function() {
		MyWindow.close();

		window.sellsyapp.$store.state.popupPanel.popupMailchimpSettings.props = { mode: 'settings' }
		window.sellsyapp.$store.state.popupPanel.popupMailchimpSettings.display = true

		var self = this;
		var options = {
			title	: Loc.g("Préférences MailChimp"),
			buttons	:[
                {
                    text : Loc.g("Fermer"), 
                    class: 'btn btn-default',
					click : function(){
						MyWindow.close();
					}
				},
                {
                    text : Loc.g("Enregistrer"), 
                    class: 'btn btn-primary',
					click : function(){
						self.record(true);
					}
				}
			],
			callback	: function(){
				Mailchimp.preparePrefsForm();
				Mailchimp.prepareSyncForm();
				Mailchimp.prepareContactYesForm();
			},
			width: 500
		};
		
		var fileOpt = {action:""};
		// MyWindow.load("mailchimp_prefs", fileOpt, options);
	},
	
	preparePrefsForm : function() {
		var formId = "mcpForm";
		var options = {
			success:function(data){Mailchimp.recordCallback(data);}, 
			dataType:"json"
		};
		MyForm.prepare(formId, "mailchimp_prefs&action=record", options, true);
		MyFacture.initEvent("#"+formId);
	},

	record: function(close) {
		var self = this;
		$(self.selector.form).submit();
		if (close) {
			MyWindow.close();
		}
	},
	
	recordCallback : function(data){
		var self = this;
		var formIsOk = MyForm.processJson(data, "mcpForm", "popupWindow");

		if ($(self.selector.inputReload).length) {
			this.loadPrefs();
		}
		var fileOpt = {action:""};
		$("#mcp_defaultList").empty();
		
		if(data.mcError.length != 0){
            Push.error(data.mcError.message);
			$('#mcLists').fadeOut();
			$('#mcSyncForm').fadeOut();
		}else{
			var opts = '<option value=""></option>';
			for(var i = 0; i < data.mcLists.length; i++){
				var list = data.mcLists[i];

				var selected = "";
				if(data.mcprefs.defaultList !== undefined && data.mcprefs.defaultList == list.id){
					selected = 'selected="true"';
				}
				opts += '<option value="'+list.id+'" '+selected+'>'+list.name+'</option>';
			}
			$('#mcp_defaultList').html(opts);
			MyFacture.customForm();
			$('#mcLists:hidden').fadeIn(300, function(){MyFacture.customForm();});
			$('#mcSyncForm').fadeIn(300, function(){MyFacture.customForm();});

			if (true === self.callSync) {
				self.callSync = false;
				$(self.selector.formSync).submit();	
			}
		}
	},
	
	prepareSyncForm : function(){
		var formId = "mcSyncForm";
		var options = {
			success:function(data){Mailchimp.syncCallback(data);},
			dataType:"json",
		};
		MyForm.prepare(formId, "mailchimp_sync&action=allContacts", options, true);
		MyFacture.initEvent("#"+formId);
		MyFacture.customForm("#"+formId);
	},

	sync: function() {
		var self = this;
		self.callSync = true;
		self.record(false);
	},

	syncCallback : function(data){
		MyWindow.close();
		Push.info(data.response);
	},
	
	prepareContactYesForm : function(){
		var formId = "mccontactYesForm";
		var options = {success:function(data){
			MyWindow.alert(Loc.g('Vos contacts ont bien été mis à jour.'), {
				type:'confirm'
			});
			MyWindow.awake();
			MyWindow.enable();
		}, dataType:"json"};
		var data = {action: 'contactMCYes'};
		MyForm.prepare(formId, "mailchimp_prefs&" + $.param(data), options, true);
		MyFacture.initEvent("#"+formId);
	},
	
	togglePres : function(){
		$('#noPres').css('display','none');
		$('#pres').css('display','block');
	},
	
	changeList: function(target)
	{
		var self   = this;
		var select = $(target);
		var value  = select.val();
		var wrapper = $(self.selector.listFieldsWrapper);

		// Soumission du formulaire
		select.parents('form').submit();
		
		// On met à jour l'affichage
		$(self.selector.listFields).each(function(i) {
			$(this).removeClass('open');
			$(this).addClass('hidden');
		});
		if ("" != value) {
			$('#'+value).addClass('open');
			$('#'+value).removeClass('hidden');
			wrapper.addClass('open');
			wrapper.removeClass('hidden');
		} else {
			wrapper.removeClass('open');
			wrapper.addClass('hidden');
		}
	}
};